import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    new TomSelect(this.element, { create: true, allowEmptyOption: false, hidePlaceholder: true });
  }
}
